import { LayoutGrid, Smartphone, Mail } from "lucide-react";

export const FORMATS = [
  { id: "post", label: "Post Social", sub: "Feed · 1:1", icon: LayoutGrid, aspect: "1 / 1" },
  { id: "story", label: "Story", sub: "IG · FB · Telegram · 9:16", icon: Smartphone, aspect: "9 / 16" },
  { id: "email", label: "Email", sub: "Newsletter · 16:9", icon: Mail, aspect: "16 / 9" },
];

export function FormatSelector({ value, onChange, color, testid }) {
  return (
    <div className="grid grid-cols-3 gap-2 mb-3" role="radiogroup" data-testid={testid}>
      {FORMATS.map((f) => {
        const active = value === f.id;
        const Icon = f.icon;
        return (
          <button key={f.id} type="button" role="radio" aria-checked={active}
            data-testid={`${testid}-${f.id}`} onClick={() => onChange(f.id)}
            className="flex items-center gap-2 rounded-xl px-2.5 py-2 text-left border transition-colors"
            style={{ borderColor: active ? color : "rgba(255,255,255,0.08)", background: active ? `${color}1f` : "rgba(255,255,255,0.03)" }}>
            <Icon className="h-4 w-4 shrink-0" style={{ color: active ? color : "#94a3b8" }} />
            <span className="min-w-0">
              <span className="block text-xs font-semibold truncate">{f.label}</span>
              <span className="block text-[10px] text-slate-400 truncate">{f.sub}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
